import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { useTeamSchedule } from "./TeamScheduleContext.js";
import { DropdownMenu } from "@swivu/shared-ui/src/components/DropdownMenu.js";
import { cn, useIsGummy } from "@swivu/shared-ui";

const TeamScheduleDropdown = () => {
  const {
    groupBy,
    handleGroupBy,
    view,
    views,
    setView,
    infoDensities,
    setInfoDensity,
    infoDensity,
    viewId
  } = useTeamSchedule();
  const isGummy = useIsGummy();
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={cn(
          "mobile-pref-control-tight outline-hidden ring-0",
          isGummy
            ? cn(
                "inline-flex h-12 w-12 items-center justify-center rounded-surface-md text-mono-800 dark:text-mono-200",
                "bg-tile-neutral font-display font-black",
                "transition-transform duration-150 gummy-lift active:translate-y-0 active:scale-[0.96] motion-reduce:transform-none",
                "shadow-raised",
                "focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary-400/40"
              )
            : "p-1"
        )}
      >
        <EllipsisVerticalIcon
          className="mobile-pref-control-icon mobile-pref-detail-icon size-6"
          aria-hidden="true"
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        align="end"
        side="bottom"
        className={cn(
          "w-60",
          isGummy && "rounded-surface-md p-2 bg-tile-neutral shadow-card-deep"
        )}
      >
        {/* if it's team scheduler, allow grouping by task or resource */}
        {!viewId && (
          <>
            <DropdownMenu.Label className="mobile-pref-card-meta font-normal">
              <div className="flex flex-col space-y-1">Group by</div>
            </DropdownMenu.Label>
            {/* <DropdownMenu.Separator /> */}
            <DropdownMenu.RadioGroup
              value={groupBy}
              onValueChange={(group) => handleGroupBy(group as typeof groupBy)}
            >
              <DropdownMenu.RadioItem
                className="mobile-pref-menu-item"
                value="task"
              >
                Task
              </DropdownMenu.RadioItem>
              <DropdownMenu.RadioItem
                className="mobile-pref-menu-item"
                value="resource"
              >
                Resource
              </DropdownMenu.RadioItem>
            </DropdownMenu.RadioGroup>
            <DropdownMenu.Separator />
          </>
        )}
        <DropdownMenu.Label className="mobile-pref-card-meta font-normal">
          <div className="flex flex-col space-y-1">View</div>
        </DropdownMenu.Label>
        {/* <DropdownMenu.Separator /> */}
        <DropdownMenu.RadioGroup
          value={view.value}
          onValueChange={(value) =>
            setView(views.find((v) => v.value === value)!)
          }
        >
          {views.map((view) => (
            <DropdownMenu.RadioItem
              className="mobile-pref-menu-item"
              key={view.text}
              value={view.value}
            >
              {view.text}
            </DropdownMenu.RadioItem>
          ))}
        </DropdownMenu.RadioGroup>
        <DropdownMenu.Separator />
        <DropdownMenu.Label className="mobile-pref-card-meta font-normal">
          <div className="flex flex-col space-y-1">Info density</div>
        </DropdownMenu.Label>
        <DropdownMenu.RadioGroup
          value={infoDensity.value}
          onValueChange={(value) =>
            setInfoDensity(infoDensities.find((v) => v.value === value)!)
          }
        >
          {infoDensities.map((info) => (
            <DropdownMenu.RadioItem
              className="mobile-pref-menu-item"
              key={info.text}
              value={info.value}
            >
              {info.text}
            </DropdownMenu.RadioItem>
          ))}
        </DropdownMenu.RadioGroup>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

export default TeamScheduleDropdown;
